var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeptTree',{attrs:{"showCompany":false,"items":_vm.items,"current":_vm.dept,"onExpand":_vm.handleExpand},on:{"selectDept":_vm.selectDept}})
}
var staticRenderFns = []

export { render, staticRenderFns }